export interface Breakpoints {
  desktopLarge: '@media (min-width:2600px)';
  desktopMedium: '@media (min-width:1900px)';
  desktopSmall: '@media (min-width:1600px)';
  laptopMedium: '@media (min-width:1400px)';
  laptopSmall: '@media (min-width:1200px)';
  tabletLarge: '@media (min-width:1100px)';
  tabletMedium: '@media (min-width:1024px)';
  tabletSmall: '@media (min-width:768px)';
  mobileLarge: '@media (min-width:414px)';
  mobileMedium: '@media (min-width:375px)';
}

export const breakpoints: Breakpoints = {
  desktopLarge: '@media (min-width:2600px)',
  desktopMedium: '@media (min-width:1900px)',
  desktopSmall: '@media (min-width:1600px)',
  laptopMedium: '@media (min-width:1400px)',
  laptopSmall: '@media (min-width:1200px)',
  tabletLarge: '@media (min-width:1100px)',
  tabletMedium: '@media (min-width:1024px)',
  tabletSmall: '@media (min-width:768px)',
  mobileLarge: '@media (min-width:414px)',
  mobileMedium: '@media (min-width:375px)',
};
